var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ChevronLeft component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconChevronLeft extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9635 2.32465C17.2564 2.61754 17.2564 3.09242 16.9635 3.38531L8.3488 12L16.9635 20.6147C17.2564 20.9075 17.2564 21.3824 16.9635 21.6753C16.6706 21.9682 16.1957 21.9682 15.9028 21.6753L7.25709 13.0296C7.11984 12.8982 7.01021 12.7407 6.93469 12.5662C6.85731 12.3875 6.81738 12.1948 6.81738 12C6.81738 11.8052 6.85731 11.6125 6.93469 11.4337C7.01021 11.2593 7.11984 11.1017 7.25709 10.9704L15.9028 2.32465C16.1957 2.03176 16.6706 2.03176 16.9635 2.32465Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconChevronLeft.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronLeft.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronLeft.prototype, "size", void 0);
if (customElements.get('cat-icon-chevron-left') === undefined) {
    customElements.define('cat-icon-chevron-left', BlocksIconChevronLeft);
}
